import React from 'react';
import GitHubCalendarComponent from './Github';

const ContributionChart = () => {
  return (
    <div>
      
      <GitHubCalendarComponent username="aryanndwi123" />
    </div>
  );
};

export default ContributionChart;
